import { render, staticRenderFns } from "./ResourcePurchasing.vue?vue&type=template&id=b321bee4&lang=pug"
import script from "./ResourcePurchasing.vue?vue&type=script&lang=js"
export * from "./ResourcePurchasing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports